import { render } from "./HomePermessi.vue?vue&type=template&id=245b56fc&ts=true"
import script from "./HomePermessi.vue?vue&type=script&lang=ts"
export * from "./HomePermessi.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__